import * as React from 'react';
import { ToastContainer as TC } from 'react-toastify';
const ToastContainer = () => {
    return React.createElement(TC, { autoClose: 5000, position: "bottom-right" });
};
export default ToastContainer;
